import React, { useRef, useEffect, useMemo } from "react";
import {
  formatPlayerTime,
  preciseInterval,
  getCurrentEditorTrackItemList,
  isOfCanPlayEditorType,
} from "@/utils/tool";
import store from "@/stores/clipEditor/player";
import trackStore from "@/stores/clipEditor/trackState";
import { observer } from "mobx-react";
import { IconPauseCircle, IconPlayCircle } from "@arco-design/web-react/icon";

interface PlayerControlProps {
  disable?: boolean;
}

const PlayerControl: React.FC<PlayerControlProps> = ({ disable = false }) => {
  const playTimer = useRef<{ cancel: () => void } | null>(null);

  // 格式化播放时间
  const playTime = useMemo(() => {
    return formatPlayerTime(store.playStartFrame);
  }, [store.playStartFrame]);

  // 格式化总时间
  const allTime = useMemo(() => {
    return formatPlayerTime(trackStore.getFrameCount());
  }, [trackStore.getFrameCount()]);

  // 视频暂停
  const pauseVideo = () => {
    if (disable) return;
    store.setPause(true);
    playTimer.current?.cancel();

    const trackItemList = getCurrentEditorTrackItemList(
      trackStore.trackList,
      store.playStartFrame,
      isOfCanPlayEditorType
    );

    trackItemList.forEach((item) => {
      item?.pause();
    });
  };

  // 开始播放
  const startPlay = () => {
    if (disable) return;
    if (store.playStartFrame >= trackStore.getFrameCount()) {
      store.playStartFrame = 0;
    }
    // store.isPause = false;
    store.setPause(false);
    playTimer.current?.cancel();
    playTimer.current = preciseInterval(() => {
      const f = store.playStartFrame + 1;
      store.setPlayStartFrame(f);
      if (store.playStartFrame >= trackStore.getFrameCount()) {
        pauseVideo();
      }
    }, 1000 / 30);
  };

  // 监听 isPause 变化
  useEffect(() => {
    if (store.isPause) {
      pauseVideo();
    }
  }, [store.isPause]);

  // 监听 playStartFrame 变化
  useEffect(() => {
    if (!store.isPause) {
      // 播放声音，查询当前帧的数据
      console.log(
        "xxxxxxx",
        trackStore.trackList,
        store.playStartFrame,
        isOfCanPlayEditorType
      );

      const trackItemList = getCurrentEditorTrackItemList(
        trackStore.trackList,
        store.playStartFrame,
        isOfCanPlayEditorType
      );
      console.log("trackItemList", trackItemList);

      trackItemList.forEach((item) => {
        item?.play(store.playStartFrame);
      });
    }
  }, [store.playStartFrame]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        height: "24px",
        padding: "8px 8px 0",
        fontSize: "12px",
      }}
    >
      <div
        className="absolute left-4 h-full text-xs leading-8"
        style={{ position: "absolute", left: 0 }}
      >
        <span className="text-blue-400 mr-1 w-20 inline-block">
          {playTime}{" "}
        </span>
        /<span className="ml-2 w-20"> {allTime}</span>
      </div>
      <div className="m-auto flex items-center">
        <div
          className={`cursor-pointer box-content ${disable ? "cursor-not-allowed" : "cursor-pointer"}`}
          style={{ cursor: "pointer", color: "#666" }}
          onClick={store.isPause ? startPlay : pauseVideo}
        >
          {store.isPause ? (
            <IconPlayCircle style={{ fontSize: 24 }} />
          ) : (
            <IconPauseCircle style={{ fontSize: 24 }} />
          )}
        </div>
      </div>
    </div>
  );
};

export default observer(PlayerControl);
